export default {
  title: 'Financial year',

  general: {
    statusTypes: {
      all: 'All',
      active: 'Active',
      disActive: 'inactive'
    },

    table: {
      header: {
        rowNumber: 'Row',
        name: 'Name',
        startDate: 'Start date',
        endDate: 'End date',
        status: 'Status',
        show: 'Show'
      }
    },

    notifications: {
      isActived: 'The desired financial year has already been activated',

      insert: {
        success: 'The new financial year was successfully registered',
        error: 'Register financial year has error'
      },

      edit: {
        success: 'Financial year was successfully edited',
        error: 'Edit financial year has error'
      },

      switch: {
        success: 'Financial year successfully switched',
        error: 'Switch financial year has error'
      },

      parseError: {
        period: 'The selected fiscal year time range is not valid',
        paymentGateways: 'The balance of a number of payment gateways has not been announced!',
        storeroom: 'A number of warehouse pull in have not been confirmed!',
        periodNotEnded: 'The current financial year has not yet ended!'
      }
    },

    confirmations: {
      insert: {
        title: 'Insert financial year confirmation',
        body: 'Are you sure about creating a new financial year?'
      },

      show: {
        title: 'View financial year confirmation',
        body: 'Are you sure you want view {name} fiscal year?'
      }
    }
  },

  edit: {
    title: 'Financial year configuration',

    periodTypes: {
      3: '3 months',
      6: '6 months',
      12: '1 year'
    },

    labels: {
      name: 'Name',
      startDate: 'Start Date',
      endDate: 'End Date',
      period: 'Financial year time range'
    }
  }
}
